import type { useNavigate } from "@tanstack/react-router";

import { IconArrowRightTop } from "@synthesis/shared-icons";
import { Button, Tag } from "@synthesis/shared-ui";

type NavigateFn = ReturnType<typeof useNavigate>;

const formatFileSize = (bytes: number) => {
  if (!bytes) return "0 Б";
  const units = ["Б", "Кб", "Мб", "Гб", "Тб"];
  const kb = 1024;
  const index = Math.floor(Math.log(bytes) / Math.log(kb));
  const value = bytes / kb ** index;
  return `${value.toFixed(index === 0 ? 0 : 1)} ${units[index]}`;
};

export const tableColumnsDetailedFileReport = [
  { field: "modelName", headerName: "Имя файла" },
  { field: "modelSize", headerName: "Размер", valueFormatter: ({ value }: { value: number }) => formatFileSize(value) },
  { field: "modelVersion", headerName: "Версия в «П-3Д»" },
  { field: "softwareVersion", headerName: "Версия ПО" },
  { field: "createdAt", headerName: "Дата загрузки" },
  { field: "fileCreatedAt", headerName: "Дата создания" },
  { field: "organizationName", headerName: "Организация" },
  { field: "projectName", headerName: "Проект" },
  { field: "projectNumber", headerName: "№ проекта" },
  {
    field: "projectStatus",
    headerName: "Статус",
    cellRenderer: (row: { value: boolean }) => (
      <Tag status={row.value ? "NEUTRAL" : "SUCCESS"} size="sm">
        {row.value ? "Архив" : "В работе"}
      </Tag>
    ),
  },
];

export const tableColumnsStatisticsUsageSoftware = (navigate: NavigateFn) => [
  { field: "total", headerName: "", sortable: false },
  { field: "softwareName", headerName: "Програмное обеспечение", flex: 1 },
  { field: "softwareVersion", headerName: "Версия" },
  { field: "modelCount", headerName: "Количество файлов" },
  {
    field: "details",
    headerName: "",
    cellRenderer: ({ data }: { data: { isTotal?: boolean; softwareName?: string } }) => (
      <div className="flex h-full items-center justify-center">
        <Button
          size="sm"
          leftIcon={<IconArrowRightTop className="size-5" />}
          onClick={() => {
            if (!data.isTotal) {
              navigate({
                to: "/reports/detailed-file-report",
                search: { softwareName: data.softwareName },
              });
            } else {
              navigate({ to: "/reports/detailed-file-report" });
            }
          }}
        >
          Детально
        </Button>
      </div>
    ),
  },
];

export const defaultColDef = {
  filter: false,
  sortable: false,
  suppressMenu: true,
};
